import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Container from "../styles/Container";
import { ItemsGrid } from "../styles/Grids";

const HeroContainer = styled.header`
  background: var(--blue);
  color: var(--white);
  padding: 12rem 0;

  h1 {
    font-size: clamp(2em, 10vw, 6em);
  }

  p {
    font-size: clamp(1em, 2vw, 1.4em);
    margin: 0 0 0 4rem;
  }
`;
const fadeLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0 },
};
const fadeRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
};

export default function Hero({ title, subtitle }) {
  return (
    <HeroContainer>
      <Container>
        <ItemsGrid>
          <motion.h1
            variants={fadeLeft}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.3 }}
          >
            {title}
          </motion.h1>
          <motion.p
            variants={fadeRight}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.6 }}
          >
            {subtitle}
          </motion.p>
        </ItemsGrid>
      </Container>
    </HeroContainer>
  );
}
